// extracted by mini-css-extract-plugin
module.exports = {"tag":"MusicalGenres__tag___16KVE","selected":"MusicalGenres__selected___OA7gp"};